module.exports = __webpack_public_path__ + "img/mouse_scroll.b433064f.svg";